<template>
  <ok-modal
    :value="value"
    size="lg"
    dialog-class="insights-modal"
    :title="$t('instagram.media-analytic')"
    @change="$emit('input',false)"
  >
    <error-alert
      v-if="error"
      :error="error"
    />
    <fetching-data-spinner
      :error="error"
      :loading="loading"
      :loading-title="$t('instagram.loading-analysis')"
      enable-retry
      @retry="loadInsight"
    />
    <b-row v-if="!loading && !error">
      <b-col
        md="6"
        sm="12"
      >
        <statistic-card-horizontal
          icon="ActivityIcon"
          :statistic="(data['engagement']?data['engagement']:0)"
          :statistic-title="$t('instagram.engagement')"
        />
      </b-col>
      <b-col
        md="6"
        sm="12"
      >
        <statistic-card-horizontal
          icon="EyeIcon"
          color="danger"
          :statistic="(data['impressions']?data['impressions']:0)"
          :statistic-title="$t('instagram.impressions')"
        />
      </b-col>
      <b-col
        md="6"
        sm="12"
      >
        <statistic-card-horizontal
          icon="LoaderIcon"
          color="warning"
          :statistic="(data['reach']?data['reach']:0)"
          :statistic-title="$t('instagram.reach')"
        />
      </b-col>
      <b-col
        md="6"
        sm="12"
      >
        <statistic-card-horizontal
          icon="SaveIcon"
          color="success"
          :statistic="(data['saved']?data['saved']:0)"
          :statistic-title="$t('instagram.saved')"
        />
      </b-col>
    </b-row>
    <template #actions>
      <div class="d-flex justify-content-end align-items-center">
        <b-button
          variant="dark"
          class="ml-1"
          @click="$emit('input',false)"
        >
          {{ $t('forms.close') }}
        </b-button>
      </div>
    </template>
  </ok-modal>
</template>

<script>
import {
  BButton, BRow, BCol,
} from 'bootstrap-vue'
import OkModal from '@/@bya3/components/modals/OkModal'
import ErrorAlert from '@/@bya3/components/alerts/ErrorAlert'
import InstagramMediaApi from '@/api/instagram/media'
import { mapGetters } from 'vuex'
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal'
import FetchingDataSpinner from '@/@bya3/components/utils/FetchingDataSpinner'

export default {
  name: 'InsightsModal',
  components: {
    FetchingDataSpinner,
    StatisticCardHorizontal,
    ErrorAlert,
    OkModal,
    BButton,
    BRow,
    BCol,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    post: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      error: null,
      loading: false,
      data: {},
    }
  },
  computed: {
    ...mapGetters({
      currentPage: 'instagram/currentAccount',
    }),
  },
  watch: {
    post() {
      this.error = null
      this.loadInsight()
    },
  },
  mounted() {
    this.loadInsight()
  },
  methods: {
    async loadInsight() {
      this.loading = true
      await InstagramMediaApi.mediaInsight(this.post.id, this.currentPage.id).then(res => {
        if (res.error === 0) {
          this.data = res.data
        }
      }).catch(e => {
        this.error = e
      })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
